import { Navigate, RouteObject } from "react-router";
import { CalculationRoute } from "@/routes/base-data/processes/rlt/calculation/calculation-route";
import { OfferRoute } from "@/routes/base-data/processes/rlt/offer/offer-route";
import { ContractRoute } from "@/routes/base-data/processes/rlt/contract/contract-route";

export const rltBaseDataRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="calculation" replace />,
  },
  {
    path: "calculation",
    element: <CalculationRoute />,
  },
  {
    path: "offer",
    element: <OfferRoute />,
  },
  {
    path: "contract",
    element: <ContractRoute />,
  },
];
